var bW = document.documentElement.clientWidth;
var bH = document.documentElement.clientHeight;
var scrollTop = $(window).scrollTop();
$(window).on('resize', function () {
  bW = document.documentElement.clientWidth;
  bH = document.documentElement.clientHeight;
})

/* -------- common -------- */
//common js-inview js-fadeIn
$(function(){
  $(".js-inview").on("inview", function (event, isInView) {
    if (isInView) {
      $(this).stop().addClass("is-show");
    } else {
      $(this).stop().removeClass("is-show");
    }
  });
});

/* -------- top -------- */
$(function () {
  if(pageID == 'top'){
    //top concept desc01
    gsap.fromTo(".js-concept_desc01", {
      y:10,
      'filter': 'blur(5px)',
      opacity: 0,
    },
    {
      y:0,
      'filter': 'blur(0px)',
      opacity: 1,
      duration: 1.6,
      ease: "power4.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".js-concept_desc01",
        start: "top center",
        toggleActions: "play play play reverse", 
        //scrub: true,
      },
    }
    );

    //top concept desc02
    gsap.fromTo(".js-concept_desc02", {
        y:10,
        'filter': 'blur(5px)',
        opacity: 0,
      },
      {
        y:0,
        'filter': 'blur(0px)',
        opacity: 1,
        duration: 1.6,
        ease: "power4.out",
        stagger: 0.15,
        scrollTrigger: {
          trigger: ".js-concept_desc02",
          start: "top center",
          toggleActions: "play play play reverse", 
          //scrub: true,
        },
      }
    );

    //top linkarea
    gsap.fromTo(".js-linkarea", {
      'filter': 'blur(5px)',
      opacity: 0,
    },
    {
      'filter': 'blur(0px)',
      opacity: 1,
      duration: 2,
      ease: "power4.out",
      stagger: 0.15,
      scrollTrigger: {
        trigger: ".p-shoplink__ul",
        start: "top center",
        toggleActions: "play play play reverse", 
      },
    }
    );

    //top lookbook
    gsap.fromTo(".p-lookbook__titlearea__line",{
      width: 0,
    },
    {
      width: 'calc(100% + .8em)',
      duration: .6,
      scrollTrigger: {
        trigger: ".p-lookbook__titlearea__line",
        toggleActions: "play play play reverse", 
      },
    });
  };
}); /* -------- top -------- */





